import type { CapiProductPage, ProductStockListings } from './capi/pdp';
import type {
  Image,
  Price,
  ProductLevelStockStatus,
  ProductListItem,
  ProductSubType
} from './capi/shared';
import type {
  CapiSoleMarketSelection,
  Listing
} from './capi/soleMarketSellerSelection';

export type TrackableProduct = {
  brand: string;
  genders: string[];
  image: Image;
  legacy_id: string;
  model: string;
  name: string;
  price: Price;
  product_id: number;
  queryID?: string;
  stock_listings?: ProductStockListings;
  stock_status: ProductLevelStockStatus;
  style_code: string;
  sub_type: ProductSubType;
};

export function fromCapiProductPage(page: CapiProductPage): TrackableProduct {
  return {
    ...page,
    image: page.gallery[0] as Image
  };
}

export function fromProductListItem(
  listItem: ProductListItem
): TrackableProduct {
  return {
    ...listItem,
    product_id: listItem.id
  };
}

export function fromSoleMarketSelectionPage(
  page: CapiSoleMarketSelection,
  listing: Listing
): TrackableProduct {
  return {
    brand: page.brand,
    genders: page.genders,
    image: page.product_image,
    legacy_id: page.legacy_id,
    model: page.model,
    name: page.product_name,
    price: {
      currency: 'GBP',
      regular: parseFloat(listing.total_price)
    },
    product_id: page.product_id,
    stock_status: page.stock_status,
    style_code: page.style_code,
    sub_type: 'sneaker'
  };
}
